import { FallbackProps } from 'react-error-boundary';

export const ErrorFallback = ({ error } : FallbackProps) => {
  const message = !!error?.message?.length
    ? error.message
    : 'We can not process your request at the moment...';
  return (
    <span data-testid="fallback-error-message">
      { message }
    </span>
  );
}
